module.exports = __webpack_public_path__ + "static/media/landing-bg.5045e1ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-bg.jpg
// module id = 23
// module chunks = 0